<template>
  <aside
    class="drawer"
    :class="{ 'is-compact': isDrawerCompact }"
  >
    <div class="content">
      <cta-menu
        v-if="layoutData?.siteSidebar?.ctaMenu?.isShow"
        :items="getContent(layoutData, defaultLocaleLayoutData, 'siteSidebar.ctaMenu.items')"
      />

      <atomic-menu-play-bingo
        v-if="false"
        v-bind="getContent(layoutData, defaultLocaleLayoutData, 'siteSidebar.questsMenuItem')"
      />

      <atomic-menu-special
        v-if="false"
        v-bind="getContent(layoutData, defaultLocaleLayoutData, 'siteSidebar.questsMenuItem')"
      />

      <atomic-menu-special
        v-if="false"
        v-bind="getContent(layoutData, defaultLocaleLayoutData, 'siteSidebar.tournamentsMenuItem')"
      />

      <!--      Games -->
      <atomic-menu-category
        :items="gamesMenu"
        url="/games"
        :label="getContent(layoutData, defaultLocaleLayoutData, 'siteSidebar.gamesMenu.label')"
        :is-drawer-compact="isDrawerCompact"
        icon="games-active"
      />

      <atomic-menu-install-app type="drawer" />

      <!-- Sports -->
      <atomic-menu-category
        v-bind="sportsMenu"
        url="/sport"
        :is-drawer-compact="isDrawerCompact"
        :icon="sportIcon"
      />

      <!-- Racing -->
      <atomic-menu-category
        v-if="false"
        v-bind="racingMenu"
        url="/racing"
        :is-drawer-compact="isDrawerCompact"
        :icon="racingIcon"
      />

      <!-- Bonuses -->
      <atomic-menu-category
        v-bind="bonusesMenu"
        url="/bonuses"
        :is-drawer-compact="isDrawerCompact"
        icon="bonus-active"
        close-on-compact
        has-hover-dropdown
      >
        <template
          v-if="activeBonusesAndFreeSpins"
          #activator
        >
          <span class="bonus-count">
            {{ activeBonusesAndFreeSpins }}
          </span>
        </template>
      </atomic-menu-category>

      <atomic-theme-switcher :is-drawer-compact="isDrawerCompact" />

      <atomic-divider
        class="drawer__divider"
        role="separator"
      />

      <nav-static :items="getContent(layoutData, defaultLocaleLayoutData, 'siteSidebar.sidebarFooterMenu')" />
    </div>
  </aside>
</template>

<script setup lang="ts">
import { buildMenu } from '@skeleton/utils/menuBuilder';
import { GAMES_MENU } from '@skeleton/consts/menus/site-sidebar';

import type { IMenuLink } from '@skeleton/utils/menuBuilder';

const { layoutData, defaultLocaleLayoutData } = storeToRefs(useGlobalStore());
const { getContent } = useProjectMethods();
const { isDrawerCompact } = storeToRefs(useLayoutStore());
const { activePlayerBonuses, activePlayerFreeSpins } = storeToRefs(useBonusStore());
const colorMode = useColorMode();

const activeBonusesAndFreeSpins = computed(() => {
  return (activePlayerBonuses.value?.length || 0) + (activePlayerFreeSpins.value?.length || 0);
});

const gamesMenu = computed((): IMenuLink[] => {
  return buildMenu(GAMES_MENU, layoutData.value, defaultLocaleLayoutData.value);
});

const sportsMenu = computed(() => {
  return getContent(layoutData.value, defaultLocaleLayoutData.value, 'siteSidebar.sportsMenu');
});

const bonusesMenu = computed(() => {
  return getContent(layoutData.value, defaultLocaleLayoutData.value, 'siteSidebar.bonusesMenu');
});

const sportIcon = computed(() => {
  return colorMode.value === 'dark' ? 'sport-dark-active' : 'sport-light-active';
});

const racingMenu = computed(() => {
  return getContent(layoutData.value, defaultLocaleLayoutData.value, 'siteSidebar.racingMenu');
});

const racingIcon = computed(() => {
  return colorMode.value === 'dark' ? 'racing-dark-active' : 'racing-light-active';
});
</script>

<style src="~/assets/styles/components/layout/drawer.scss" lang="scss" />
